import { Box, CardContent } from '@mui/material';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { isEmpty } from '../../../../helpers/utilityFunctions/utilityFunctions';
import { ParameterCard } from '../../../documented/ParameterCard';
import IconLoader from '../../../IconLoader';
import { TotalStepsCardData } from './totalStepsCardData';

interface TotalStepsCardProps {
  data?: TotalStepsCardData;
  onClick: (arg: string) => void;
}

const CardDetailTypography = styled(Typography)(() => ({
  fontSize: 14,
  padding: '0px 0px 0px 16px !important',
}));

const TotalStepsCardMedia = styled(CardContent)(() => ({
  display: 'flex !important',
  flexDirection: 'column',
  flexGrow: '1 !important',
}));

const PanelDisplayBox = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
}));

const TotalStepsCard: React.FC<TotalStepsCardProps> = ({
  onClick,
  data,
}: TotalStepsCardProps) => {
  const { t } = useTranslation('cards');
  return (
    <ParameterCard
      title={t('totalSteps.title')}
      iconName="TotalSteps"
      popoverContent={t('totalSteps.popover')}
      onClick={() => onClick('_10MWT')}
      enabled={!isEmpty(data)}
    >
      <CardDetailTypography>
        {t('totalSteps.description')}
      </CardDetailTypography>
      <TotalStepsCardMedia>
        <PanelDisplayBox>
          <IconLoader name="TotalStepsCardFeet" />
          <Typography sx={{ fontWeight: 'bold', fontSize: 57 }}>
            {data ? Number(data.value) : 0}
          </Typography>
          <Typography sx={{ fontWeight: 'bold', fontSize: 14 }}>
            {data ? data.unit : 'Steps'}
          </Typography>
        </PanelDisplayBox>
      </TotalStepsCardMedia>
    </ParameterCard>
  );
};

export default TotalStepsCard;
